import React from 'react';
export function PainSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-197">
      <div className="max-w-3xl mx-auto text-center md:text-left" data-id="element-198">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E]" data-id="element-199">
          Si sos docente de primaria, dejame hacerte una pregunta honesta:
        </h2>

        <p className="text-xl md:text-2xl font-bold text-red-600 mb-3 text-center" data-id="element-200">
          ¿Sentis que cada efemeride te roba mucho tiempo?
        </p>

        <div className="text-lg text-gray-700 space-y-2 mb-4" data-id="element-201">
          <p data-id="element-202"></p>
          <p data-id="element-203"></p>
          <p className="font-bold" data-id="element-204">
            <span className="px-1 bg-[#FFFFFF]" data-id="element-205">
              Es porque cada fecha del calendario escolar te obliga a volver a
              buscar material, pensar actividades y preparar todo otra vez.
            </span>
          </p>
        </div>

        <p className="text-lg text-gray-700 font-medium" data-id="element-206">
          Y entre planificaciones, clases, reuniones y correcciones terminás
          dedicando horas a algo que podría resolverse mucho más rápido.
        </p>

        <p className="text-xl font-bold text-center mt-4 text-gray-900" data-id="element-207">
          Trabajar las efemérides no debería quitarte tanto tiempo.
        </p>
      </div>
    </section>;
}